"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginContributionIndex = void 0;
const json_validator_1 = require("@harbor/json-validator");
const utils_1 = require("../utils");
const internationalize_1 = require("./internationalize");
const ui_config_schema_json_1 = __importDefault(require("../ui-config-json/ui-config.schema.json"));
// import {UiConfigJson, UiConfigJsonContribution} from "../ui-config-json";
class PluginContributionIndex {
    // eslint-disable-next-line
    constructor(i18nLocale) {
        this.i18nLocale = i18nLocale;
        this.index = {};
        this.jsonValidator = new json_validator_1.JsonValidator();
        this.jsonValidator.addSchema(ui_config_schema_json_1.default);
    }
    getIndex() {
        return this.index;
    }
    build(uiConfigs) {
        this.appendValidSchemaDefinitions(uiConfigs);
        this.index = {};
        for (const config of uiConfigs) {
            this.index[config.pluginId] = {
                pluginId: config.pluginId,
                baseUrl: config.baseUrl,
                modulePreload: config.modulePreload || {},
                extensionPoints: this.validExtensionPointDefs(config),
                contributions: [],
                title: config.title || ""
            };
        }
        this.appendContributionData(uiConfigs);
        return this.index;
    }
    getTargetData(target) {
        const [receivingPluginId, extensionPointName] = target.split("/");
        return { receivingPluginId, extensionPointName };
    }
    appendContributionData(uiConfigs) {
        for (const uiConfig of uiConfigs) {
            const pluginFilter = uiConfig.$filter;
            for (const [target, contribs] of Object.entries(uiConfig.contributions || {})) {
                const { receivingPluginId, extensionPointName } = this.getTargetData(target);
                const receivingPlugin = this.index[receivingPluginId];
                if (receivingPlugin) {
                    this.validContributions(receivingPlugin, extensionPointName, uiConfig.pluginId, (0, utils_1.deepFlatten)([contribs || []])).forEach(contribution => {
                        if (extensionPointName) {
                            contribution.extensionPoint = extensionPointName;
                        }
                        // eslint-disable-next-line
                        if (pluginFilter && !contribution.hasOwnProperty("$filter")) {
                            contribution.$filter = pluginFilter;
                        }
                        const contrib = {
                            sourcePluginId: uiConfig.pluginId,
                            contribution: null,
                        };
                        Object.defineProperty(contrib, "contribution", {
                            enumerable: true,
                            get: (0, utils_1.memoized)(() => (0, internationalize_1.internationalize)(contribution, uiConfig, this.i18nLocale))
                        });
                        receivingPlugin.contributions.push(contrib);
                    });
                }
            }
        }
    }
    appendValidSchemaDefinitions(uiConfigs) {
        for (const uiConfig of uiConfigs) {
            const validTypes = {};
            for (const [typeName, typeSchema] of Object.entries(uiConfig.schemaDefinitions || {})) {
                const errorMessage = this.validateSchema(typeSchema);
                if (errorMessage) {
                    // eslint-disable-next-line
                    console.error(// NOSONAR
                    "Invalid schemaDefinition '%s' in plugin '%s':\n %s", typeName, uiConfig.pluginId, errorMessage);
                }
                else {
                    validTypes[typeName] = typeSchema;
                }
            }
            if (Object.keys(validTypes).length) {
                this.jsonValidator.addSchema(uiConfig.schemaDefinitions, `/${uiConfig.pluginId}/schemaDefinitions`);
            }
        }
    }
    validContributions(receivingPlugin, extensionPointName, sourcePluginId, contributions) {
        return contributions.filter(contribution => {
            if (!(contribution instanceof Object)) {
                // eslint-disable-next-line no-console
                console.error("Invalid contribution data '%s'", JSON.stringify(contribution));
                return false;
            }
            const extensionPoint = extensionPointName || contribution.extensionPoint;
            const extensionPointDef = receivingPlugin.extensionPoints[extensionPoint];
            if (extensionPointDef) {
                // the extension schema may be empty, in which case
                // we don't attempt to validate anything
                return Object.keys(extensionPointDef).length
                    ? this.validateContribution(extensionPointDef, extensionPointName, receivingPlugin.pluginId, contribution, sourcePluginId)
                    : true;
            }
            else {
                return true;
            }
        });
    }
    validateContribution(extensionPointDef, extensionPointName, receivingPluginId, contribution, sourcePluginId) {
        const res = this.jsonValidator.validate((0, utils_1.omit)(contribution, ["extensionPoint", "requiredPermissions"]), extensionPointDef);
        if (!res.valid) {
            // eslint-disable-next-line
            console.error(// NOSONAR
            "Invalid contribution from '%s' to '%s/%s':\n'%s'\nContribution data:\n%o", sourcePluginId, receivingPluginId, extensionPointName || contribution.extensionPoint, this.jsonValidator.errorsText(res.errors), contribution);
            return false;
        }
        return true;
    }
    validExtensionPointDefs(uiConfig) {
        const { pluginId } = uiConfig;
        const validPoints = {};
        for (const [id, schema] of Object.entries(uiConfig.extensionPoints || {})) {
            if (this.validateExtensionPointDef(pluginId, id, schema)) {
                validPoints[id] = schema;
            }
        }
        return validPoints;
    }
    validateExtensionPointDef(pluginId, extensionPointId, extensionSchema) {
        const errorMessage = this.validateSchema(extensionSchema);
        if (errorMessage) {
            // eslint-disable-next-line
            console.error(// NOSONAR
            "Invalid extension point definition '%s/%s':\n %s\nDefinition:\n%o", pluginId, extensionPointId, errorMessage, extensionSchema);
        }
        return !errorMessage;
    }
    validateSchema(schema) {
        let errorMessage = null;
        try {
            const res = this.jsonValidator.validateSchema(schema);
            if (!res.valid) {
                errorMessage = this.jsonValidator.errorsText(res.errors);
            }
        }
        catch (e) {
            errorMessage = e.message;
        }
        return errorMessage;
    }
}
exports.PluginContributionIndex = PluginContributionIndex;
